export default __webpack_public_path__ + "static/media/graignes19.908776e4.jpg";